<template>
  <svg
    style="width: 24px; height: 24px"
    :style="{ transform: getDirection }"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >

    <!-- Old arrow: <path d="M4,10V14H13L9.5,17.5L11.92,19.92L19.84,12L11.92,4.08L9.5,6.5L13,10H4Z"/> -->
    <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z"/>
  </svg>
</template>
<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  direction: {
    type: String,
    default: 'right',
  },
  size: {
    type: String,
    default: '24px',
  },
});
const getDirection = computed(() => {
  switch (props.direction) {
    case 'down':
      return 'rotate(90deg)';
    case 'up':
      return 'rotate(-90deg)';
    case 'left':
      return 'rotate(180deg)';
    case 'right':
      return '';
    default:
      return '';
  }
});
</script>
<style lang="scss" scoped></style>
